import * as React from "react";

import { isQuestionDisabled } from "@teamprevent/common/questionnaires/questionnaireConfig/models";

import { AnsweredQuestion } from "@teamprevent/common/model";

import { QuestionConfig } from "../../../questionnaireConfig";

import { PointCircles } from "./PointCircles";
import { ImageAnnotatorQuestionPointActions } from "./ImageAnnotatorQuestionPointActions";
import { Point } from "./models";

interface Props {
    answer?: Point[];
    imageHref: string;
    className?: string;
    updateQuestion?: (answer: AnsweredQuestion) => void;
    readonly?: boolean;
    questionConfig: QuestionConfig;
    allowNotes?: boolean;
}

export const getPointKey = (point: Point) => `${point.x},${point.y}`;

export const ImageAnnotatorQuestion: React.FunctionComponent<Props> = props => {
    const questionConfig = props.questionConfig;
    if (isQuestionDisabled(questionConfig)) {
        return null;
    }

    const points = props.answer || [];

    const setNotes = (pointIndex: number, notes: string) => {
        const newPoints = [...points.slice(0, pointIndex), { ...points[pointIndex], notes }, ...points.slice(pointIndex + 1)];
        onPointsChanged(newPoints);
    };

    const removePoint = (pointIndex: number) => {
        const newPoints = points.filter((p, i) => i !== pointIndex);
        onPointsChanged(newPoints);
    };

    const onPointsChanged = (newPoints: Point[]) => {
        if (props.updateQuestion) {
            props.updateQuestion({ ...props.questionConfig, question: questionConfig.questionText, answer: newPoints, isValid: true });
        }
    };

    const onClick = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        if (props.readonly) {
            return;
        }
        const svgRect = event.currentTarget.getClientRects()[0];
        const newPoint = { x: event.clientX - svgRect.left, y: event.clientY - svgRect.top, notes: "" };
        if (points.some(p => p.x === newPoint.x && p.y === newPoint.y)) {
            return;
        }
        const newPoints = [...points, newPoint];
        onPointsChanged(newPoints);
    };

    return (
        <>
            <div>{questionConfig.questionText}</div>
            <svg className={`image-annotator-question ${props.className}`} onMouseDown={onClick}>
                <image width="100%" height="100%" href={props.imageHref} />
                <PointCircles numberPoints={props.allowNotes} points={points} />
            </svg>
            {points.map((p, index) =>
                (<ImageAnnotatorQuestionPointActions
                    key={getPointKey(p)}
                    label={index + 1}
                    notes={p.notes}
                    // eslint-disable-next-line react/jsx-no-bind
                    onUpdate={value => setNotes(index, value)}
                    // eslint-disable-next-line react/jsx-no-bind
                    onRemove={() => removePoint(index)}
                    readonly={props.readonly}
                    allowNotes={props.allowNotes}
                />)
            )}
        </>
    );
};
